import { ReactElement, ReactNode } from 'react';
import { useEntityPageContent } from '../../state/EntityPage';

export interface EntityPageContentProps {
  /**
   * <EntityPage.MainContent> and, if needed, <EntityPage.AdditionalContent> elements
   */
  children: ReactNode;
}

export type EntityPageContentElement = ReactElement<
  EntityPageContentProps,
  typeof EntityPageContent
>;

export function EntityPageContent(_props: EntityPageContentProps) {
  return null;
}

EntityPageContent.useEntityPageContent = useEntityPageContent;
EntityPageContent.displayName = 'EntityPageContent';
